import meetTheTeamTemplate from "./templates/meet-the-team";
import ourConsultantsTemplate from "./templates/our-consultants";
import locationsTemplate from "./templates/locations";
import supportServicesTemplate from "./templates/support-services";
import medicalServicesTemplate from "./templates/medical-services";
import cookiePolicyTemplate from "./templates/cookie-policy";

export default {
    type: 'pages',
    aliases: {
        camel: 'pages',
        singular: 'Page',
        plural: 'Pages',
        lowerSingular: 'page',
        lowerPlural: 'pages',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'page-modules',
                localKey: 'pageId',
                foreignKey: 'moduleId'
            }
        },
    },
    publishable: true,
    adminSection: null,
    componentType: 'base',
    filterOn: {
        'other': ['publishYear', 'isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPageCollection',
            loader: () => import('./AdministerPageCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerPageRecord',
            loader: () => import('./AdministerPageRecord')
        },
        webRecord: {
            name: 'DisplayPageRecord',
            loader: () => import('./DisplayPageRecord'),
            templates: [
                meetTheTeamTemplate,
                ourConsultantsTemplate,
                locationsTemplate,
                supportServicesTemplate,
                medicalServicesTemplate,
                cookiePolicyTemplate,
            ]
        },
    }
};
